import { render, staticRenderFns } from "./oldHouse.vue?vue&type=template&id=7a74af7b&scoped=true&"
import script from "./oldHouse.vue?vue&type=script&lang=js&"
export * from "./oldHouse.vue?vue&type=script&lang=js&"
import style0 from "./oldHouse.vue?vue&type=style&index=0&id=7a74af7b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a74af7b",
  null
  
)

export default component.exports